/* ===== BASANTI SHOPIFY THEME JS ===== */

/* ── Device detection ── */
const IS_IOS    = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
const IS_MOBILE = IS_IOS || /Android/i.test(navigator.userAgent);

/* Force-play muted inline video — required on iOS */
function forcePlayVideo(el) {
  if (!el) return;
  el.muted = true;
  el.setAttribute('muted', '');
  el.setAttribute('playsinline', '');
  el.setAttribute('webkit-playsinline', '');
  const p = el.play();
  if (p && typeof p.catch === 'function') p.catch(() => {});
}

/* ── Navbar ── */
function initNavbar() {
  const navbar    = document.getElementById('navbar');
  const hamburger = document.getElementById('hamburger');
  const mobileMenu = document.getElementById('mobileMenu');
  if (!navbar) return;

  hamburger?.addEventListener('click', () => mobileMenu?.classList.toggle('open'));
}

/* ── Background video (autoplay loop on all devices) ── */
function initBgVideo() {
  const bgVideo  = document.getElementById('bgVideo');
  const overlay  = document.getElementById('bgVideoOverlay');
  const s56Video = document.getElementById('s56Video');

  if (!bgVideo) return;

  /* bgVideo: autoplay loop always */
  bgVideo.removeAttribute('preload');
  bgVideo.setAttribute('autoplay', '');
  bgVideo.setAttribute('loop', '');
  bgVideo.loop          = true;
  bgVideo.style.opacity = '1';
  forcePlayVideo(bgVideo);

  /* s56Video: autoplay loop, hidden until its section is visible */
  if (s56Video) {
    s56Video.setAttribute('autoplay', '');
    s56Video.setAttribute('loop', '');
    s56Video.loop          = true;
    s56Video.style.opacity = '0';
    forcePlayVideo(s56Video);
  }

  const heroContent = document.querySelector('.hero__content');
  const heroStats   = document.querySelector('.hero__stats');
  const faqEl       = document.getElementById('faq');

  /* bgVideo fades out just before FAQ starts; s56Video covers FAQ + sections 5 & 6 */
  function getBgFadeStart() {
    return faqEl
      ? faqEl.offsetTop - window.innerHeight * 0.3
      : window.innerHeight * 99;
  }

  let ticking = false;
  window.addEventListener('scroll', () => {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(() => {
      const scrolled  = window.scrollY;
      const vh        = window.innerHeight;
      const fadeStart = getBgFadeStart();

      /* hero parallax + fade */
      const heroOpacity = Math.max(0, 1 - scrolled / (vh * 0.55));
      if (heroContent) {
        heroContent.style.opacity   = heroOpacity;
        heroContent.style.transform = `translateY(-${scrolled * 0.18}%)`;
      }
      if (heroStats) heroStats.style.opacity = heroOpacity;

      /* bgVideo: visible through Hero → Gallery, fades out before FAQ */
      const bgOpacity = scrolled < fadeStart
        ? 1
        : Math.max(0, 1 - (scrolled - fadeStart) / (vh * 0.5));
      bgVideo.style.opacity = bgOpacity;
      if (overlay) overlay.style.opacity = bgOpacity;

      /* s56Video: show from FAQ section onwards (FAQ + Testimonials + Contact) */
      if (s56Video) {
        const trigger = faqEl || document.getElementById('sections56Wrap');
        if (trigger) {
          const rect   = trigger.getBoundingClientRect();
          const inZone = rect.top < vh * 1.1;
          s56Video.style.opacity = inZone ? '1' : '0';
        }
      }

      ticking = false;
    });
  }, { passive: true });
}

/* ── About / Gallery autoplay background videos ── */
function initAutoplayVideos() {
  document.querySelectorAll('video[autoplay]').forEach(v => forcePlayVideo(v));
}

/* ── Cart Sidebar (Shopify AJAX Cart API) ── */
function toggleCart(forceClose = false) {
  const sidebar  = document.getElementById('cartSidebar');
  const overlay  = document.getElementById('cartOverlay');
  if (!sidebar) return;
  const isOpen   = sidebar.classList.contains('open');
  const shouldOpen = forceClose ? false : !isOpen;
  sidebar.classList.toggle('open', shouldOpen);
  overlay?.classList.toggle('open', shouldOpen);
  document.body.style.overflow = shouldOpen ? 'hidden' : '';
  if (shouldOpen) refreshCart();
}

document.addEventListener('keydown', e => {
  if (e.key === 'Escape') toggleCart(true);
});

async function fetchCart() {
  const res = await fetch('/cart.js');
  return res.json();
}

async function refreshCart() {
  const cart = await fetchCart();
  renderCartSidebar(cart);
}

function renderCartSidebar(cart) {
  const badge      = document.getElementById('cartBadge');
  const emptyEl    = document.getElementById('cartEmpty');
  const itemsWrap  = document.getElementById('cartItemsWrap');
  const itemsEl    = document.getElementById('cartItems');
  const footer     = document.getElementById('cartFooter');
  const subtotalEl = document.getElementById('cartSubtotal');
  const totalEl    = document.getElementById('cartTotal');

  if (badge) badge.textContent = cart.item_count;

  if (cart.item_count === 0) {
    if (emptyEl)  emptyEl.style.display  = 'flex';
    if (itemsWrap) itemsWrap.style.display = 'none';
    if (footer)   footer.style.display   = 'none';
    return;
  }

  if (emptyEl)  emptyEl.style.display  = 'none';
  if (itemsWrap) itemsWrap.style.display = 'block';
  if (footer)   footer.style.display   = 'block';

  if (subtotalEl) subtotalEl.textContent = formatMoney(cart.items_subtotal_price);
  if (totalEl)    totalEl.textContent    = formatMoney(cart.total_price);

  if (itemsEl) {
    itemsEl.innerHTML = cart.items.map(item => `
      <li class="cart-item">
        <a href="${item.url}">
          <img class="cart-item__img" src="${item.image}" alt="${item.title}">
        </a>
        <div class="cart-item__info">
          <div class="cart-item__name">${item.product_title}</div>
          ${item.variant_title && item.variant_title !== 'Default Title'
            ? `<div style="font-size:11px;color:rgba(255,255,255,0.35);margin-bottom:3px;">${item.variant_title}</div>`
            : ''}
          <div class="cart-item__price">${formatMoney(item.final_line_price)}</div>
          <div class="cart-item__qty">
            <button class="cart-item__qty-btn" onclick="changeCartItem('${item.key}',${item.quantity - 1})">−</button>
            <span class="cart-item__qty-val">${item.quantity}</span>
            <button class="cart-item__qty-btn" onclick="changeCartItem('${item.key}',${item.quantity + 1})">+</button>
          </div>
        </div>
        <button class="cart-item__remove" onclick="changeCartItem('${item.key}',0)" title="Remove">
          <svg width="16" height="16" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
            <polyline points="3 6 5 6 21 6"/><path d="M19 6l-1 14H6L5 6"/>
            <path d="M10 11v6M14 11v6M9 6V4h6v2"/>
          </svg>
        </button>
      </li>
    `).join('');
  }
}

async function changeCartItem(key, quantity) {
  await fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: key, quantity })
  });
  await refreshCart();
}

async function addToCartShopify(variantId, btn) {
  const origHTML = btn ? btn.innerHTML : '';
  if (btn) { btn.innerHTML = '✓ Adding...'; btn.disabled = true; }
  try {
    await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    });
    await refreshCart();
    toggleCart(false);
    if (btn) {
      btn.classList.add('added');
      btn.innerHTML = '✓ Added!';
      setTimeout(() => { btn.innerHTML = origHTML; btn.classList.remove('added'); btn.disabled = false; }, 2000);
    }
  } catch (err) {
    console.error('Add to cart error:', err);
    if (btn) { btn.innerHTML = origHTML; btn.disabled = false; }
  }
}

function formatMoney(cents) {
  return new Intl.NumberFormat('en-IN', { style: 'currency', currency: 'INR', minimumFractionDigits: 0 }).format(cents / 100);
}

/* ── Product card hover video ── */
function initCardVideos() {
  document.querySelectorAll('.pcard--has-video').forEach(card => {
    const video = card.querySelector('.pcard__video');
    if (!video) return;
    card.addEventListener('mouseenter', () => video.play().catch(() => {}));
    card.addEventListener('mouseleave', () => { video.pause(); video.currentTime = 0; });
  });
}

/* ── Product card image swap ── */
function swapCardImg(dotBtn, src) {
  const card = dotBtn.closest('.pcard');
  if (!card) return;
  const img = card.querySelector('.pcard__img');
  if (img) img.src = src;
  card.querySelectorAll('.pcard__photo-dot').forEach(d => d.classList.remove('active'));
  dotBtn.classList.add('active');
}

/* ── Hero particle canvas ── */
function initHeroCanvas() {
  const canvas = document.getElementById('heroCanvas');
  if (!canvas) return;
  const ctx = canvas.getContext('2d');
  function resize() { canvas.width = canvas.offsetWidth; canvas.height = canvas.offsetHeight; }
  resize();
  window.addEventListener('resize', resize);

  const particles = Array.from({ length: 70 }, () => ({
    x: Math.random() * canvas.width, y: Math.random() * canvas.height,
    r: Math.random() * 1.5 + 0.4,
    vx: (Math.random() - 0.5) * 0.35, vy: (Math.random() - 0.5) * 0.35,
    o: Math.random() * 0.35 + 0.08
  }));

  function draw() {
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    particles.forEach(p => {
      ctx.beginPath(); ctx.arc(p.x, p.y, p.r, 0, Math.PI * 2);
      ctx.fillStyle = `rgba(200,130,74,${p.o})`; ctx.fill();
      p.x += p.vx; p.y += p.vy;
      if (p.x < 0 || p.x > canvas.width)  p.vx *= -1;
      if (p.y < 0 || p.y > canvas.height) p.vy *= -1;
    });
    requestAnimationFrame(draw);
  }
  draw();
}

/* ── Testimonials slider ── */
function initTestimonials() {
  let current = 0;
  const slides = document.querySelectorAll('.testimonial-slide');
  const dots   = document.querySelectorAll('.testimonials__dot');
  if (!slides.length) return;

  function go(idx) {
    slides.forEach((s, i) => s.classList.toggle('active', i === idx));
    dots.forEach((d, i)   => d.classList.toggle('active', i === idx));
    current = idx;
  }

  document.getElementById('testimonialPrev')?.addEventListener('click', () => go((current - 1 + slides.length) % slides.length));
  document.getElementById('testimonialNext')?.addEventListener('click', () => go((current + 1) % slides.length));
  dots.forEach((d, i) => d.addEventListener('click', () => go(i)));
  setInterval(() => go((current + 1) % slides.length), 4500);
}

/* ── Gallery ── */
function initGallery() {
  const mainImg = document.getElementById('galleryMainImg');
  const caption = document.getElementById('galleryCaption');
  const dots    = document.querySelectorAll('.gallery__dot');
  if (!mainImg || !dots.length) return;

  let current   = 0;
  let autoTimer = null;

  function setGallery(idx) {
    current = idx;
    const dot = dots[idx];
    if (!dot) return;
    mainImg.style.opacity = '0';
    setTimeout(() => {
      mainImg.src           = dot.dataset.src || '';
      mainImg.alt           = dot.dataset.alt || '';
      mainImg.style.opacity = '1';
    }, 200);
    if (caption) caption.textContent = `${String(idx + 1).padStart(2, '0')} — ${dot.dataset.alt || ''}`;
    dots.forEach((d, i) => d.classList.toggle('active', i === idx));
  }

  function startAuto() {
    clearInterval(autoTimer);
    autoTimer = setInterval(() => setGallery((current + 1) % dots.length), 3000);
  }

  dots.forEach((d, i) => d.addEventListener('click', () => { setGallery(i); startAuto(); }));
  document.getElementById('galleryPrev')?.addEventListener('click', () => { setGallery((current - 1 + dots.length) % dots.length); startAuto(); });
  document.getElementById('galleryNext')?.addEventListener('click', () => { setGallery((current + 1) % dots.length); startAuto(); });

  setGallery(0);
  startAuto();
}

/* ── About stat counters ── */
function runCounters() {
  document.querySelectorAll('.stat-card__num[data-target]').forEach(el => {
    if (el.dataset.counted) return;
    el.dataset.counted = '1';
    const end    = parseInt(el.dataset.target) || 0;
    const suffix = el.dataset.suffix || '';
    let current  = 0;
    const step   = Math.ceil(end / 60);
    const timer  = setInterval(() => {
      current = Math.min(current + step, end);
      el.textContent = current + suffix;
      if (current >= end) clearInterval(timer);
    }, 25);
  });
}

function initAboutStats() {
  // On pages without cube flip (e.g. /pages/about), fire counters via IntersectionObserver
  if (document.getElementById('aboutFlipWrap')) return;
  const els = document.querySelectorAll('.stat-card__num[data-target]');
  if (!els.length) return;
  const obs = new IntersectionObserver(entries => {
    entries.forEach(e => { if (e.isIntersecting) { runCounters(); obs.disconnect(); } });
  }, { threshold: 0.3 });
  els.forEach(el => obs.observe(el));
}

/* ── Scroll reveal ── */
function initReveal() {
  const obs = new IntersectionObserver(entries => {
    entries.forEach(e => {
      if (e.isIntersecting) { e.target.classList.add('revealed'); obs.unobserve(e.target); }
    });
  }, { threshold: 0.12 });
  document.querySelectorAll('.reveal, .reveal-left, .reveal-right, [data-reveal]').forEach(el => obs.observe(el));
}

/* ── Cube flip (about section) ── */
function initCubeFlip() {
  const cubeWrap = document.getElementById('aboutFlipWrap');
  const cubeFace = document.querySelector('#aboutFlipSticky section');
  if (!cubeWrap || !cubeFace) return;

  let countersFired = false;
  window.addEventListener('scroll', () => {
    const vh      = window.innerHeight;
    const wrapTop = cubeWrap.getBoundingClientRect().top;
    const raw     = (vh - wrapTop) / vh;
    const progress = Math.min(1, Math.max(0, raw));
    const ease     = 1 - Math.pow(1 - progress, 3);
    cubeFace.style.transform = `rotateX(${90 - ease * 90}deg)`;
    cubeFace.style.opacity   = Math.min(1, progress / 0.5);
    if (!countersFired && progress >= 0.7) {
      countersFired = true;
      runCounters();
    }
  }, { passive: true });

  // mobile: no cube flip, fire counters when section enters viewport
  if (window.innerWidth <= 768) {
    const obs = new IntersectionObserver(entries => {
      entries.forEach(e => { if (e.isIntersecting) { runCounters(); obs.disconnect(); } });
    }, { threshold: 0.3 });
    obs.observe(cubeWrap);
  }
}

/* ── Detail page thumb switcher ── */
function initDetailPage() {
  document.querySelectorAll('.detail-thumb').forEach(thumb => {
    thumb.addEventListener('click', () => {
      document.querySelectorAll('.detail-thumb').forEach(t => t.classList.remove('active'));
      thumb.classList.add('active');
      const mainImg   = document.getElementById('detailMainImgEl');
      const mainVideo = document.getElementById('detailMainVideoEl');
      if (!mainImg) return;
      if (thumb.dataset.type === 'video' && mainVideo) {
        mainImg.style.display   = 'none';
        mainVideo.src           = thumb.dataset.videoSrc;
        mainVideo.style.display = '';
        mainVideo.play().catch(() => {});
      } else {
        if (mainVideo) { mainVideo.pause(); mainVideo.style.display = 'none'; }
        mainImg.style.display = '';
        if (thumb.dataset.src) mainImg.src = thumb.dataset.src;
      }
    });
  });
}

/* ── Razorpay Checkout ── */
async function startRazorpayCheckout() {
  if (!window.Razorpay) {
    alert('Payment gateway is loading, please try again in a moment.');
    return;
  }

  let cart;
  try {
    cart = await fetchCart();
  } catch (e) {
    alert('Could not load cart. Please try again.');
    return;
  }

  if (!cart || cart.item_count === 0) {
    alert('Your cart is empty.');
    return;
  }

  const amountPaise = cart.total_price; /* Shopify returns paise (100ths of rupee = paise) */

  const options = {
    key:         window.BASANTI_RAZORPAY_KEY,
    amount:      amountPaise,
    currency:    window.BASANTI_CURRENCY || 'INR',
    name:        window.BASANTI_SHOP_NAME || 'BASANTI',
    description: 'Luxury Dinner Sets',
    image:       document.querySelector('link[rel="icon"]')?.href || '',
    prefill: {
      contact: '',
      email:   ''
    },
    theme: { color: '#c8824a' },
    modal: {
      ondismiss: () => {}
    },
    handler: function (response) {
      /* Payment successful — redirect to Shopify checkout to complete order */
      const payId = response.razorpay_payment_id;
      const note  = encodeURIComponent('Razorpay Payment ID: ' + payId);
      window.location.href = window.BASANTI_ROUTES.checkout + '?note=' + note;
    }
  };

  try {
    const rzp = new window.Razorpay(options);
    rzp.on('payment.failed', function (resp) {
      alert('Payment failed: ' + (resp.error.description || 'Unknown error'));
    });
    rzp.open();
  } catch (e) {
    console.error('Razorpay error:', e);
    alert('Could not open payment window. Please try again.');
  }
}

/* ── WhatsApp COD order builder ── */
function buildCartWaLink(cart) {
  const waBtn = document.getElementById('cartWaBtn');
  if (!waBtn || !cart || !cart.items) return;
  const lines = cart.items.map(i => `• ${i.product_title} × ${i.quantity} — ${formatMoney(i.final_line_price)}`).join('\n');
  const total = formatMoney(cart.total_price);
  const msg   = `Hi! I want to place an order:\n\n${lines}\n\nTotal: ${total}\n\nPlease confirm.`;
  waBtn.href  = `https://wa.me/${window.BASANTI_WA_NUMBER}?text=${encodeURIComponent(msg)}`;
}

/* Override refreshCart to also update WhatsApp link */
const _origRefreshCart = refreshCart;
async function refreshCart() {
  const cart = await fetchCart();
  renderCartSidebar(cart);
  buildCartWaLink(cart);
}

/* ── FAQ Accordion ── */
function initFaq() {
  document.querySelectorAll('.faq__item').forEach(item => {
    const btn = item.querySelector('.faq__question');
    if (!btn) return;
    btn.addEventListener('click', () => {
      const isOpen = item.classList.contains('open');
      document.querySelectorAll('.faq__item.open').forEach(o => {
        o.classList.remove('open');
        o.querySelector('.faq__question').setAttribute('aria-expanded', 'false');
      });
      if (!isOpen) {
        item.classList.add('open');
        btn.setAttribute('aria-expanded', 'true');
      }
    });
  });
}

/* ── Init ── */
document.addEventListener('DOMContentLoaded', () => {
  initNavbar();
  initBgVideo();
  initAutoplayVideos();
  initHeroCanvas();
  initTestimonials();
  initGallery();
  initAboutStats();
  initReveal();
  initCubeFlip();
  initDetailPage();
  initCardVideos();
  initFaq();
  refreshCart();
});
